/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vbWFya2V0aW5nL3RyYW5zbGF0b3IvYnVsay1lbWFpbC10cmFuc2xhdG9yL2J1bGstZW1haWwtdHJhbnNsYXRvci5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
